import { useQuery } from '@tanstack/react-query';
import { gamesApi } from '../../api/games';
import type { GameSummary } from '../../types';

// Shared loader: fetches the enabled games list and returns the summary for one
// slug (with sensible fallback bet limits if the API hasn't loaded yet).
export function useGameConfig(slug: GameSummary['slug']) {
  const query = useQuery({
    queryKey: ['games'],
    queryFn: () => gamesApi.listGames(),
  });
  const game = query.data?.games.find((g) => g.slug === slug) ?? null;
  return {
    ...query,
    game,
    enabled: !!game,
    minBet: game?.minBet ?? 10,
    maxBet: game?.maxBet ?? 1000,
  };
}
